import {CameraApp} from './app/camera/CameraApp.js';
window.CameraApp = CameraApp;

import {EtoilesApp} from './app/etoiles/EtoilesApp.js';
window.EtoilesApp = EtoilesApp;

import {CerveauApp} from './app/cerveau/CerveauApp.js';
window.CerveauApp = CerveauApp;

import {BiodiversiteApp} from './app/biodiversite/BiodiversiteApp.js';
window.BiodiversiteApp = BiodiversiteApp;
